import { useEffect } from 'react'
import { createPortal } from 'react-dom'

/** How long a message stays before it fades. */
const LINGER = 2600

/**
 * A brief confirmation for actions that otherwise leave no trace — copying a
 * note to the clipboard looks identical to nothing happening.
 *
 * Portalled to <body> for the same reason the menus are: the panes it would
 * otherwise sit inside clip and reposition their children.
 */
export function Toast({ message, onDone }: { message: string; onDone: () => void }) {
  useEffect(() => {
    const t = setTimeout(onDone, LINGER)
    return () => clearTimeout(t)
  }, [message, onDone])

  return createPortal(
    <div className="toast" role="status" aria-live="polite">{message}</div>,
    document.body,
  )
}
